<template>
    <div class="relevancy-tab">
        <!-- 关联的tab -->
        <div v-for="(item,i) in data" :key="i">
            <span id="name" >{{ item.name }}</span>

            <!--<i class="iconfont icon-shanchu"　@click="delTab(item)"></i>-->
            <div class="delBtn" @click="delTab(item)" ></div>
        </div>
    </div>
</template>

<script>
    var oSpan = document.getElementById('name')
    export default {
        props:{
            data:Array,
            getData:Function
        },
        data() {
            return {}
        },
        created() {

        },
        methods: {
            delTab(obj){
                let id = obj.id;
                let index;
                this.data.forEach((item,i)=> {
                    if(item.id == id){
                        index = i;
                    }
                });
                this.data.splice(index,1);
                this.getData(this.data);
            },

        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .relevancy-tab{
        >div{
            display: inline-block;

        }
        p{
            margin-right: 10px;
            width:100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        i{
            cursor: pointer;
            color: #F37258;
        }

        .delBtn{
            display: inline-block;
            background: #1890ff;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            margin: 0 10px;
            &:hover{
                cursor:pointer;
                background: red;
            }
        }


    }
</style>
